import enums from '@/utils/enums';
import { hasPermission } from '@/utils';
import { BANNER } from '../utils/constants';

export default {
  computed: {
    bannerItems() {
      return this.$store.getters[BANNER.GET_BANNERS];
    },
    bannerLoading() {
      return this.$store.getters[BANNER.GET_BANNER_LOADING];
    }
  },
  methods: {
    async getBanners() {
      if (!hasPermission(enums.bannerViewProfiles)) return;
      await this.$store.dispatch(BANNER.FETCH_BANNERS, {
        enterpriseParams: this.getByEnterpriseParams
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/banner.js